<template>
  <div class="map-search-div"
    :style="{
      top: props.top,
      right: props.right,
      width: props.width,
    }"
  >
    <div class="search-box">
      <input
        v-model="searchText"
        type="text" 
        data-placeholder="SEARCH" 
        autocomplete="off" 
        spellcheck="false" 
        autocorrect="off" 
        autocapitalize="off"
        placeholder="搜索..."
        @keyup.enter="searchFun"
        class="search-dom"
      />
      <input
        type="button"
        value="搜索"
        @click="searchFun"
        class="search-dom"
      />
    </div>
    <div
      class="search-content scroll-y"
      v-if="addressList.length > 0"
    >
      <div
        v-for="(address, index) in addressList"
        :key="index"
        class="search-content-div"
        @click="markerInner(address)"
      >
        <span class="result-type">{{ address.type }}</span>
        <span class="result-text">{{ address.display_name }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import axios from 'axios';
// props
const props = defineProps({
  top: { type: String, default: ()=>{ return '10px'; }, },
  right: { type: String, default: ()=>{ return '3.75rem'; }, },
  width: { type: String, default: ()=>{ return '15rem'; }, },
  map: { type: Object, required: true, },
});
// emit
const emit = defineEmits([
  
]);

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{
  markerClear();
});

let searchText = ref(''), addressList = ref([]), addressMarker;
const searchFun = ()=>{
  let content = searchText.value.replaceAll(' ', '');
  var reg =	/([0-9]*\d\.[0-9]*\d,[0-9]*\d\.[0-9]*\d)|([0-9]*\d\.[0-9]*\d,[0-9]*\d)|([0-9]*\d,[0-9]*\d\.[0-9]*\d)|([0-9]*\d,[0-9]*\d)|([0-9]*\d\.[0-9]*\d,[0-9]*\d\.[0-9]*\d)|([0-9]*\d\.[0-9]*\d,[0-9]*\d)|([0-9]*\d,-[0-9]*\d\.[0-9]*\d)|([0-9]*\d,-[0-9]*\d)/g
  if(reg.test(content)){
    let lat = content.split(',')[0];
    let lon = content.split(',')[1];
    markerInner({lat, lon});
    return;
  }
  markerRequest();
};
const markerRequest = ()=>{
  axios({
    method: "get",
    url: "https://photon.komoot.io/api/",
    params: {
      q: searchText.value,
      limit: 5,
      lang: "default",
    },
  }).then((response) => {
    console.log(response);
    if(response.status == 200){
      // Photon 返回 GeoJSON 格式，results 在 features 里
      addressList.value = (response.data.features || []).map(item => {
        const props = item.properties || {};
        return {
          display_name: [props.name, props.street, props.city, props.country].filter(Boolean).join(', '),
          lat: item.geometry?.coordinates?.[1] || props.lat,
          lon: item.geometry?.coordinates?.[0] || props.lon,
          type: props.osm_value || props.osm_key || props.type || '',
          ...props,
        };
      });
    }
  }).catch((error) => {
    addressList.value = [];
    console.log(error);
  });
}
const markerClear = ()=>{
  if(addressMarker){
    if(props.map.hasLayer(addressMarker)){
      props.map.removeLayer(addressMarker);
    }
  }
}
const markerInner = (latlng)=>{
  markerClear();
  props.map.flyTo(latlng, 11);
  addressMarker = L.marker(latlng).addTo(props.map);
}

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.map-search-div{
  margin-right: 0;
  position: absolute;
  z-index: 10;
  .search-box{
    --boxHeight: 24px;
    height: auto;
    // width: 100%;
    display: flex;
    input{
      height: var(--boxHeight);
      padding: 0px 5px;
      font-size: 12px;
      line-height: var(--boxHeight);
    }
    input[type='text']{
      width: calc(100% - 36px);
      box-sizing: border-box;
      outline: none;
    }
    input[type='button']{
      width: 36px;
      box-sizing: border-box;
      cursor: pointer;
      background-color: rgba(64, 158, 255, 1);
      color: rgba(255, 255, 255, 1);
      &:hover{
        background-color: rgba(64, 158, 255, 0.8);
      }
    }
  }
  .search-content{
    max-height: 260px;
    overflow-y: auto;
    border-radius: 0 0 6px 6px;
    &::-webkit-scrollbar {
      display: block;
      width: 4px;
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 2px;
      background: rgba(255, 255, 255, 0.25);
      &:hover {
        background: rgba(255, 255, 255, 0.4);
      }
    }
    .search-content-div{
      display: flex;
      align-items: flex-start;
      gap: 6px;
      padding: 8px 10px;
      width: 100%;
      color: #d0d0d0;
      font-size: 12px;
      line-height: 1.5;
      background-color: rgba(22, 22, 22, 0.92);
      border-bottom: 1px solid rgba(255, 255, 255, 0.08);
      cursor: pointer;
      transition: background-color 0.15s ease;
      .result-text {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        flex: 1;
      }
      .result-type {
        flex-shrink: 0;
        display: inline-block;
        padding: 1px 6px;
        font-size: 10px;
        line-height: 18px;
        color: #fff;
        background: rgba(64, 158, 255, 0.55);
        border-radius: 3px;
        margin-top: 1px;
        text-transform: capitalize;
      }
      &:hover {
        background-color: rgba(45, 45, 45, 0.95);
      }
      &:first-child {
        border-top: 1px solid rgba(255, 255, 255, 0.08);
      }
    }
  }
}
</style>